import { useMutation } from '@tanstack/react-query';

import { updateUser } from '../../../actions/entities';
import { useAxiosWithAPI } from '../../../common/hooks/useAxiosWithAPI';
import { ReactQueryKeys } from '../../../common/react-query-keys';
import { User } from '../../../models/User';
import { useAppDispatch } from '../../../store';

type QueryInput = {
  input: Record<string, unknown>;
};

type QueryOutput = {
  updatePhone: Pick<User, 'id' | 'updatedAt' | 'phone'>;
};

export default function useUpdatePhone() {
  const dispatch = useAppDispatch();
  const axios = useAxiosWithAPI();
  const {
    mutateAsync: updatePhoneMutationAsync,
    isPending,
    error,
  } = useMutation({
    mutationKey: ReactQueryKeys.updatePhone(),
    mutationFn: async (input: QueryInput['input']) => {
      const { data } = await axios.put<{
        data: QueryOutput['updatePhone'];
      }>('/me', {
        data: input,
      });

      dispatch(
        updateUser(data.data.id, {
          updatedAt: data.data.updatedAt,
          phone: data.data.phone,
        })
      );

      return data.data;
    },
  });
  const updatePhone = async (input: QueryInput['input']) => {
    await updatePhoneMutationAsync(input);
  };

  return {
    updatePhone,
    loading: isPending,
    error,
  } as const;
}
